import aeCardImage from '../../images/ae_card.png'
import applePayImage from '../../images/applepay_1.png'
import closeImage from '../../images/close_white.png'
import creditCardImage from '../../images/credit_card.js'
import weChatPayImage from '../../images/wechat_pay.js'
import gPayImage from '../../images/googlepay_1.png'
import masterCardImage from '../../images/master_card.png'
import prevImage from '../../images/previous-arrow.png'
import visaCardImage from '../../images/visa_card.png'

export default {
  wrap: {
    background: '#614D4A',
    zIndex: '1',
  },
  'prev-button': {
    background: `url(${prevImage})`,
    position: 'absolute',
    height: '30px',
    width: '30px',
    top: '15px',
    left: '15px',
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  'close-button': {
    background: `url(${closeImage})`,
    position: 'absolute',
    height: '30px',
    width: '30px',
    top: '15px',
    right: '15px',
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  header: {
    top: '50px',
    left: '15px',
    color: '#FFFFFF',
    'font-size': '25px',
    position: 'absolute',
  },
  'payment-option-wrap': {
    'margin-top': '15px',
    'margin-left': '15px',
    'margin-right': '15px',
    position: 'absolute',
    top: '180px',
    width: 'calc(100% - 15px - 15px - 20px - 20px)',
  },
  'recent-payment-option-wrap': {
    'margin-top': '15px',
    'margin-left': '15px',
    'margin-right': '15px',
    position: 'absolute',
    top: '80px',
    width: 'calc(100% - 15px - 15px - 20px - 20px)',
  },
  disabled: {
    'pointer-events': 'none',
  },
  'payment-option': {
    position: 'relative',
    overflow: 'hidden',
    background: '#fff',
    'box-shadow': '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
    'margin-bottom': '20px',
    'border-top-left-radius': '15px',
    'border-top-right-radius': '15px',
    'border-bottom-left-radius': '15px',
    'border-bottom-right-radius': '15px',
    '& > div:nth-child(2)': {
      'border-bottom': 'none !important',
      'padding-bottom': '0 !important',
    },
    width: '100%',
    height: '50px',
    'margin-top': '15px',
    'padding-left': '20px',
    'padding-right': '20px',
    'padding-top': '15px',
    'padding-bottom': '15px',

    '& iframe': {
      float: 'none !important',
    },
  },
  'payment-option-credit-card': {
    height: '50px',
    background: creditCardImage + ', url(https://res.cloudinary.com/dimorder/image/upload/v1583760602/credit_card_1.3de75fe2_ykg93k.jpg)',
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  'payment-option-wechatpay': {
    height: '50px',
    background: weChatPayImage,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  'payment-option-cash': {
    // height: '50px',
    // background: 'url()',
    // 'background-size': 'contain',
    // 'background-repeat': 'no-repeat',
  },
  'recent-payment-option-visa-card': {
    'vertical-align': 'center',
    height: '50px',
    background: `url(${visaCardImage})`,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
    'text-size': '25px',
  },
  'recent-payment-option-master-card': {
    'vertical-align': 'center',
    height: '50px',
    background: `url(${masterCardImage})`,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
    'text-size': '25px',
  },
  'recent-payment-option-ae-card': {
    'vertical-align': 'center',
    height: '50px',
    background: `url(${aeCardImage})`,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
    'text-size': '25px',
  },
  'payment-option-apple-pay': {
    height: '50px',
    background: `url(${applePayImage})`,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  'payment-option-g-pay': {
    height: '50px',
    background: `url(${gPayImage})`,
    'background-size': 'contain',
    'background-repeat': 'no-repeat',
  },
  'takeaway-summary-tel-input': {
    'border-top-left-radius': '5px',
    'border-top-right-radius': '5px',
    'border-bottom-left-radius': '5px',
    'border-bottom-right-radius': '5px',
    'margin-top': '15px',
    'margin-bottom': '5px',
    padding: '10px',
    width: 'calc(100% - 20px)',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
  },
  'takeaway-summary-tel-input::placeholder': {
    color: '#A2A2A2',
  },
  'takeaway-summary-reorder-btn': {
    position: 'fixed',
    bottom: '0',
    width: '100vw',
    background: '#D5AD40',
    color: 'white',
    left: '0',
    height: '66px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.5em',
  },
  'takeaway-summary-footer': {
    // position: 'absolute',
    // bottom: '50px',
    // width: '100%',
    background: '#4A8CA1',
    height: '70px',
    color: '#fff',
    'text-align': 'center',
    'font-size': '16px',
    'line-height': '70px',
    'vertical-align': 'middle',
    'z-index': '9',
    position: 'relative',
    bottom: '-16px',
  },
  'takeaway-summary-footer-invalid': {
    // position: 'absolute',
    // bottom: '50px',
    // width: '100%',
    height: '70px',
    color: '#fff',
    'text-align': 'center',
    'font-size': '16px',
    'line-height': '70px',
    'vertical-align': 'middle',
    'z-index': '9',
    background: '#D8D8D8',
    position: 'relative',
    bottom: '-16px',
  },
  'takeaway-summary-select': {
    background: '#fff',
    color: '#A2A2A2',
    'border-top-left-radius': '5px',
    'border-top-right-radius': '5px',
    'border-bottom-left-radius': '5px',
    'border-bottom-right-radius': '5px',
    'margin-top': '15px',
    'margin-bottom': '5px',
    padding: '10px',
    width: 'calc(100% - 20px)',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
  },
  'takeaway-waiting-background': {
    background: 'rgb(246,242,234)',
  },
  'recent-payment-option-content': {
    'font-size': '20px',
    height: '100%',
    'line-height': '50px',
    'margin-left': '70px',
  },
  'disable-overlay': {
    background: 'rgba(125, 125, 125, .5)',
    width: '100%',
    height: '100%',
    'z-index': '99',
    margin: '-15px',
    borderRadius: '15px',
  },
  invalid: {
    color: 'red',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/TakeawayPaymentSummary.js